import { render, staticRenderFns } from "./GlobalFloatingCube.vue?vue&type=template&id=19502a2e&scoped=true"
import script from "./GlobalFloatingCube.vue?vue&type=script&lang=js"
export * from "./GlobalFloatingCube.vue?vue&type=script&lang=js"
import style0 from "./GlobalFloatingCube.vue?vue&type=style&index=0&id=19502a2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19502a2e",
  null
  
)

export default component.exports